import { http } from "../../services/api/Http.interceptor";
import Notification from './interfaces/Notification';

const URL: string = '/notificaciones';

export const getNotification = () => {
    return http.get<Notification[]>(`${URL}/ims`)
}

export const getImsClose = () => {
    return http.get<Notification[]>(`${URL}/close`)
}

export const getByImsClose = (id: number) => {
    return http.get<Notification[]>(`${URL}/close/${id}`)
}

export const getImsCloseList = (id: number) => {
    return http.get<Notification[]>(`${URL}/folowup/${id}`)
}

export const getByNotification = (id: number) => {
    return http.get<Notification[]>(`${URL}/ims/${id}`)
}

export const postNotification = (notification: Notification) => {
    return http.post<Notification>(`${URL}/ims`, notification)
}

export const postFolowUp = (notification: Notification) => {
    return http.post<Notification>(`${URL}/folowup`, notification)
}

export const deleteNotification = (id: number) => {
    return http.delete<string>(`${URL}/ims/${id}`)
}

export const putNotification = (notification: Notification) => {
    return http.put<Notification>(`${URL}/ims/${notification.id}`, notification)
}